[
  "Alabama",
  "Arizona",
  "Arkansas",
  "Colorado",
  "Delaware",
  "Florida",
  "Georgia",
  "Guam",
  "Idaho",
  "Indiana",
  "Iowa",
  "Kansas",
  "Kentucky",
  "Louisiana",
  "Maine",
  "Maryland",
  "Mississippi",
  "Missouri",
  "Montana",
  "Nebraska",
  "New Hampshire",
  "New Jersey",
  "New Mexico",
  "North Carolina",
  "North Dakota",
  "Oklahoma",
  "South Carolina",
  "South Dakota",
  "Tennessee",
  "Texas",
  "Utah",
  "Vermont",
  "Virginia",
  "West Virginia",
  "Wisconsin",
  "Wyoming"
]
